module.exports = __webpack_public_path__ + "img/2951@3x.c1920cf3.png";